module.exports = __webpack_public_path__ + "static/img/rslt-logo.24c09eef.png";